import { Injectable } from '@angular/core';
import { Practitioner } from '../models/practitioner.model';
import { AngularFirestore } from '@angular/fire/firestore';
import { environment } from 'src/environments/environment';
import { Testimonial } from '../models/testimonial.model';
import { Booking } from '../models/booking.model';
import { Therapy } from '../models/therapy.model';

@Injectable()
export class MailService {
  private mailServiceOn: boolean = environment.servicesEnabled;

  constructor(private firestore: AngularFirestore){}

  sendTestimonialEmail(practitioner: Practitioner, testimonials: Testimonial[]) {
    if (!this.mailServiceOn) { return; }
    let data = {
      fullName: practitioner.firstName + ' ' + practitioner.lastName,
      practitionerId: practitioner.id,
      zayaUrl: environment.webUrl
    };

    return testimonials.forEach((testimonial: Testimonial) => {
      if (testimonial.email) {
        this._sendEmail(testimonial.email, 'testimonial', data);
      }
    });
  }

  sendPractitionerCreationEmail(practitioner: Practitioner) {
    if (!this.mailServiceOn) { return; }
    let data = {
      fullName: practitioner.firstName + ' ' + practitioner.lastName,
      zayaUrl: environment.webUrl
    };
    return this._sendEmail(practitioner.email, 'practitionerCreated', data);
  }

  sendPractitionerApprovedEmail(practitioner: Practitioner) {
    if (!this.mailServiceOn) { return; }
    let data = {
      fullName: practitioner.firstName + ' ' + practitioner.lastName,
      zayaUrl: environment.webUrl,
      practitionerRegisterUrl: environment.webUrl + 'practitioner/' + practitioner.id + '/register'
    };
    return this._sendEmail(practitioner.email, 'practitionerApproved', data);
  }

  sendPractitionerRejectedEmail(practitioner: Practitioner) {
    if (!this.mailServiceOn) { return; }
    let data = {
      fullName: practitioner.firstName + ' ' + practitioner.lastName,
      zayaUrl: environment.webUrl
    };
    return this._sendEmail(practitioner.email, 'practitionerRejected', data);
  }

  sendPractitionerApprovedConditionallyEmail(practitioner: Practitioner, feedback: string) {
    if (!this.mailServiceOn) { return; }
    let data = {
      fullName: practitioner.firstName + ' ' + practitioner.lastName,
      practitionerFeedback: feedback,
      zayaUrl: environment.webUrl,
      practitionerRegisterUrl: environment.webUrl + 'practitioner/' + practitioner.id + '/register'
    };
    return this._sendEmail(practitioner.email, 'practitionerApplicationPending', data);
  }

  sendPractitionerTestimonialReceivedEmail(practitioner: Practitioner) {
    if (!this.mailServiceOn) { return; }
    let data = {
      fullName: practitioner.firstName + ' ' + practitioner.lastName + ': ' + practitioner.email,
      zayaUrl: environment.webUrl
    }
    return this._sendEmail('caleb@bulktrainer.com', 'practitionerTestimonialReceived', data);
  }

  sendPractitionerBookingReceivedEmail(practitioner: Practitioner, booking: Booking) {
    if (!this.mailServiceOn) { return; }
    let data = {
      fullName: practitioner.getFullName(),
      zayaUrl: environment.webUrl,
      clientName: booking.firstName + ' ' + booking.lastName,
      clientEmail: booking.email,
      clientPhoneNumber: booking.phoneNumber,
      appointmentType: booking.type,
      appointmentService: Therapy.getTherapyNames(booking.services),
      clientMessage: booking.description
    }
    return this._sendEmail(practitioner.email, 'practitionerBookingReceived', data);
  }

  sendClientBookingRequestedEmail(practitioner: Practitioner, booking: Booking) {
    if (!this.mailServiceOn) { return; }
    let data = {
      fullName: booking.firstName + ' ' + booking.lastName,
      zayaUrl: environment.webUrl,
      practitionerName: practitioner.getFullName(),
      practitionerPhoneNumber: practitioner.phoneNumber,
      practitionerEmail: practitioner.email
    }
    return this._sendEmail(booking.email, 'clientBookingRequested', data);
  }

  private _sendEmail(email: String, name: string, data: Object) {
    return this.firestore.collection('mail').add({
      to: email,
      bcc: 'hello@zayamed.com',
      template: {
        name: name,
        data: data
      }
    });
  }
}
